import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

/**
 * Функция загрузки данных типов
 */
export const useLoadObjectSubTypeSelect = () => {
  const http = useHttp()

  return useQuery({
    queryKey: ['load_object_sub_type_select'],
    queryFn: () => http.get('/inventory/objects/55974/object-types/full'),
    retry: false,
  })
}
